<div class="button-container-space-holder" *appHasRole="['Admin', 'Manager', 'Preparer']">
  <div class="button-container" *appHasRole="['Admin', 'Manager', 'Preparer']">
    <div
      ngbDropdown
      class="dropdown"
      [placement]="['top-start', 'top-end']"
    >
      <app-button
        ngbDropdownToggle
        id="add-transaction-dd"
        text="Add Transaction"
        iconClass="icon ic-add-20"
        iconClassLast="icon ic-chevron-down-20"
        [loading]="isCompanyLoading()"
        [isDisabled]="isCompanyLoading()"
      />

      <div
        ngbDropdownMenu
        aria-labelledby="add-transaction-dd"
        class="common-dropdown-menu dropdown-menu dropdown-menu-right"
      >
        @for (menuItem of addTransactionMenu; track $index) {
          @if ($last) {
            <app-divider margin="4px 0"/>
          }

          <button
            ngbDropdownItem
            [disabled]="isCompanyLoading()"
            (click)="menuItem.action()"
          >
            <span>{{ menuItem.name }}</span>
          </button>
        }
      </div>
    </div>

    <div
      ngbDropdown
      class="dropdown"
      [placement]="['top-start', 'top-end']"
    >
      <app-button
        ngbDropdownToggle
        id="bulk-actions-dd"
        text="Export"
        iconClass="icon ic-download-20"
        [isDisabled]="isCompanyLoading()"
      />

      <div
        ngbDropdownMenu
        aria-labelledby="bulk-actions-dd"
        class="common-dropdown-menu dropdown-menu dropdown-menu-right"
      >
        <button
          ngbDropdownItem
          [disabled]="isCompanyLoading()"
          (click)="exportSharesList(false, ExportTypeEnum.EXCEL)"
        >
          <span>Export to xlsx</span>
        </button>

        <!--      <div ngbDropdownItem (click)="exportSharesList(false, ExportTypeEnum.CSV)">-->
        <!--        <span>Export to csv</span>-->
        <!--      </div>-->
      </div>
    </div>

    @if (hasIssue) {
      <app-divider margin="0 24px" [vertical]="true"/>

      <app-button
        text="Resolve"
        btnColor="red-orange"
        iconClass="icon ic-resolve-20"
        iconClassLast="icon ic-chevron-down-20"
        [isDisabled]="isCompanyLoading()"
        (clickBtn)="resolveIssue()"
      />
    }
  </div>
</div>
